<template>
    <div
        :id="id"
        ref="dividerEl"
        class="tl-divider"
        :class="[`tl-divider-${orientation?.toLowerCase() || 'horizontal'}`, !text && 'textless']"
    >
        <div class="line" />
        <div
            v-if="text"
            class="tl-divider-text"
            v-html="markedContent"
        />
        <div
            v-if="text"
            class="line"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import marked from 'widget-components/utilities/marked'
import type { ComponentOptions } from 'widget-components'
import { ref } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    text?: string
    orientation?: string
    options?: ComponentOptions
}>()

const dividerEl = ref<HTMLElement | null>(null)

const markedContent = computed(() => marked(props.text))
</script>

<style lang="sass" scoped>
@import "./Divider.sass"
.tl-divider
    height: var(--divider-height)
</style>
